import http from 'common/http'

export const fetchAds = () => {
  return http.get('/ads')
}
